import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolder2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-2"><path d="M2 3.75C2 3.33579 2.33579 3 2.75 3H9.94444C10.1398 3 10.3274 3.07622 10.4675 3.21246L12.3047 5H21.25C21.6642 5 22 5.33579 22 5.75V9.06301C21.8402 9.02188 21.6726 9 21.5 9H2.5C2.32735 9 2.15981 9.02188 2 9.06301V3.75Z" fill="currentColor"/><path d="M2 11V19.25C2 19.6642 2.33579 20 2.75 20H21.25C21.6642 20 22 19.6642 22 19.25V11C22 10.7239 21.7761 10.5 21.5 10.5H2.5C2.22386 10.5 2 10.7239 2 11Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFolder2;
